// extracted by mini-css-extract-plugin
export default {"errorContainer":"TransactionsForm_errorContainer__SeCvH"};